export default "__VITE_ASSET__b26610cf__"